import { deburr } from 'util/lang'

const normalize = (text: string) => deburr(text).toLowerCase()

export const filterRegistradosByQuery = <T>(
  registrados: ReadonlyArray<T>,
  query: string,
  getSearchableFields: (item: T) => ReadonlyArray<string>
): T[] => {
  const q = normalize((query ?? '').trim())
  if (!q) return [...registrados]
  return registrados.filter((it) => getSearchableFields(it).some((f) => normalize(f).includes(q)))
}

export const buildItems = <T>(
  headerRegistrados: T,
  registrados: ReadonlyArray<T>,
  headerOutros: T,
  outros: ReadonlyArray<T>,
  skipping: boolean
): T[] => {
  if (skipping) return [headerRegistrados, ...registrados, headerOutros]
  return [headerRegistrados, ...registrados, headerOutros, ...outros]
}
